module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"spotlight":"Im Rampenlicht der Medien"},"en":{"spotlight":"In the media spotlight"},"it":{"spotlight":""},"lt":{"spotlight":"Mes spaudoje"},"pl":{"spotlight":"Media o nas"}}')
  delete Component.options._Ctor
}
